import menuVariables from './menuVariables';

export default menuVariables;
